import React from 'react';

export const DateTime = ({ date, time, value, ...props}) => {

    const formatDate = () => {
        return (
            <>
                {
                    `${(new Intl.DateTimeFormat("en-US", {
                        day: "numeric"
                    })).format(value ? Date.parse(value) : new Date())}/${(new Intl.DateTimeFormat("en-US", {
                        month: "numeric"
                    })).format(value ? Date.parse(value) : new Date())}/${(new Intl.DateTimeFormat("en-US", {
                        year: "numeric"
                    })).format(value ? Date.parse(value) : new Date())}`
                }
            </>
        );
    }    
    
    const formaTime = () => {
        const checkDate = value.indexOf('Z') !== -1 ? value : value+"Z";
        return (
            <>        
                {(new Intl.DateTimeFormat("it-IT", {
                    hour: "numeric",
                    minute: "numeric",
                    //second: 'numeric'
                })).format(value ? Date.parse(checkDate) : new Date())}
            </>
        );
    }

    return(
        <>
            {date && formatDate(value)}
            &nbsp;
            {time && formaTime(value)}
        </>
    )
}